import { create } from 'zustand';

/**
 * Tiny store for the global ⌘K command palette.
 *
 * Lets any component (topbar trigger, dashboard search input, future entry
 * points) request the palette without prop-drilling through AppShell.
 */
interface CommandPaletteState {
  open: boolean;
  /** Optional query to seed the input when the palette opens. */
  initialQuery: string;
  openPalette: (initialQuery?: string) => void;
  closePalette: () => void;
}

export const useCommandPaletteStore = create<CommandPaletteState>((set) => ({
  open: false,
  initialQuery: '',
  openPalette: (initialQuery = '') => set({ open: true, initialQuery }),
  closePalette: () => set({ open: false, initialQuery: '' }),
}));
